import { render, staticRenderFns } from "./provider-contactdetails.vue?vue&type=template&id=ccf8a1fe&scoped=true"
import script from "./provider-contactdetails.vue?vue&type=script&lang=js"
export * from "./provider-contactdetails.vue?vue&type=script&lang=js"
import style0 from "./provider-contactdetails.vue?vue&type=style&index=0&id=ccf8a1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf8a1fe",
  null
  
)

export default component.exports